import React, { useEffect, useState } from 'react';
import classes from './Confetti.module.css';

const COLORS = ['#2be494', '#1665d8', '#f5a623', '#fc4b4e', '#a855f7', '#ffffff'];
const PIECE_COUNT = 60;
const LIFETIME_MS = 3000;

// Lightweight, dependency-free confetti burst — a fixed-position overlay of
// small pieces that fall/spin via CSS animation, then unmounts itself.
const Confetti = ({ onComplete }) => {
  const [pieces] = useState(() =>
    Array.from({ length: PIECE_COUNT }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      delay: Math.random() * 0.3,
      duration: 1.8 + Math.random() * 1.2,
      rotation: Math.round(Math.random() * 360),
      drift: Math.round((Math.random() - 0.5) * 120),
      size: 6 + Math.round(Math.random() * 6),
      round: Math.random() > 0.5,
    }))
  );

  useEffect(() => {
    const timer = setTimeout(() => onComplete && onComplete(), LIFETIME_MS);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={classes.confettiContainer} aria-hidden="true">
      {pieces.map(p => (
        <span
          key={p.id}
          className={classes.confettiPiece}
          style={{
            left: `${p.left}%`,
            backgroundColor: p.color,
            width: `${p.size}px`,
            height: `${p.size}px`,
            borderRadius: p.round ? '50%' : '2px',
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            '--confetti-drift': `${p.drift}px`,
            '--confetti-rotation': `${p.rotation}deg`,
          }}
        />
      ))}
    </div>
  );
};

export default Confetti;
